import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "flex gap-x-4 relative p-4 font-montserrat overflow-y-auto",
  style: {"max-height":"calc(55vh / var(--viewport-scale)) !important"}
}
const _hoisted_2 = { class: "flex flex-col gap-y-6 justify-between w-3/5" }
const _hoisted_3 = { class: "grid grid-cols-2 gap-x-2 gap-y-6 w-full items-end" }
const _hoisted_4 = {
  class: "flex items-center rounded-md border border-gray-lp-400 relative text-black-lp-100 text-sm mt-1",
  style: {"height":"2.435rem"}
}
const _hoisted_5 = {
  class: "flex items-center rounded-md border border-gray-lp-400 relative text-black-lp-100 text-sm mt-1",
  style: {"height":"2.435rem"}
}
const _hoisted_6 = { class: "col-span-2 grid grid-cols-2 gap-x-2 w-full" }
const _hoisted_7 = { class: "flex items-center gap-x-4 pb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TimeRangePicker = _resolveComponent("TimeRangePicker")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_DatePickerV2 = _resolveComponent("DatePickerV2")!
  const _component_MultipleSelectSearchVirtualScroll = _resolveComponent("MultipleSelectSearchVirtualScroll")!
  const _component_DropdownMultiSelect = _resolveComponent("DropdownMultiSelect")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.visible = $event)),
    title: "Buat daftar kargo",
    persistent: "",
    customBody: "p-0",
    customWidth: "w-3/5",
    showOverflow: false
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_TimeRangePicker, {
          startDate: _ctx.form.periodeStart,
          endDate: _ctx.form.periodeEnd,
          maxDate: new Date(),
          onSelect: _ctx.setPeriode,
          default: "custom",
          "only-panel": "",
          class: "w-2/5",
          "custom-class": "items-start",
          ref: "dateRangeFilter"
        }, null, 8, ["startDate", "endDate", "maxDate", "onSelect"]),
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_DataWrapper, { label: "Tanggal mulai booking" }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_4, [
                  _createVNode(_component_Icons, {
                    name: "calendar",
                    class: "w-4 text-gray-lp-600 absolute left-2 transform top-1/2 -translate-y-1/2",
                    fill: ""
                  }),
                  _createVNode("input", {
                    type: "text",
                    value: _ctx.periodeStartFormatted,
                    onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onBlurPeriodeStart && _ctx.onBlurPeriodeStart(...args))),
                    placeholder: "Masukan tanggal mulai",
                    class: "h-full flex items-center border-l border-gray-lp-400 ml-8 px-2 w-full rounded-r-md outline-none"
                  }, null, 40, ["value"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_DatePickerV2, {
              modelValueTime: _ctx.periodeStartTime,
              placeholder: "00:00",
              onSelectedTime: _ctx.inputDateStartTime,
              onBlur: _ctx.onValidateTime,
              showDatePicker: false,
              showTimePicker: "",
              customClass: "mb-0",
              customClassTime: "w-full",
              maxDate: new Date(new Date().setDate(new Date().getDate() + 1))
            }, null, 8, ["modelValueTime", "onSelectedTime", "onBlur", "maxDate"]),
            _createVNode(_component_DataWrapper, { label: "Tanggal sampai booking" }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_5, [
                  _createVNode(_component_Icons, {
                    name: "calendar",
                    class: "w-4 text-gray-lp-600 absolute left-2 transform top-1/2 -translate-y-1/2",
                    fill: ""
                  }),
                  _createVNode("input", {
                    type: "text",
                    value: _ctx.periodeEndFormatted,
                    onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onBlurPeriodeEnd && _ctx.onBlurPeriodeEnd(...args))),
                    placeholder: "Masukan tanggal selesai",
                    class: "h-full flex items-center border-l border-gray-lp-400 ml-8 px-2 w-full rounded-r-md outline-none"
                  }, null, 40, ["value"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_DatePickerV2, {
              modelValueTime: _ctx.periodeEndTime,
              placeholder: "00:00",
              onSelectedTime: _ctx.inputDateEndTime,
              onBlur: _ctx.onValidateTime,
              showDatePicker: false,
              showTimePicker: "",
              customClass: "mb-0",
              customClassTime: "w-full",
              maxDate: new Date(new Date().setDate(new Date().getDate() + 1))
            }, null, 8, ["modelValueTime", "onSelectedTime", "onBlur", "maxDate"]),
            _createVNode("div", _hoisted_6, [
              _createVNode(_component_DataWrapper, {
                label: "Lokasi Hub",
                optional: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_MultipleSelectSearchVirtualScroll, {
                    options: _ctx.hubList,
                    modelValue: _ctx.form.selectedHub,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.selectedHub = $event)),
                    keyName: "name",
                    keyValue: "code",
                    selectAllText: "Semua",
                    selectAllClass: "font-normal",
                    placeholder: "Pilih lokasi hub",
                    "show-select-all": true,
                    "max-displayed-chips": 2,
                    allEnabled: "",
                    selectAllOption: "",
                    onFocus: _cache[4] || (_cache[4] = () => _ctx.onFilterHub('')),
                    onFilter: _ctx.onFilterHub,
                    onChange: _ctx.onChangeHub,
                    class: "mt-1"
                  }, null, 8, ["options", "modelValue", "onFilter", "onChange"])
                ]),
                _: 1
              }),
              _createVNode(_component_DataWrapper, {
                label: "Kota tujuan",
                optional: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_MultipleSelectSearchVirtualScroll, {
                    options: _ctx.cityDestinationData,
                    modelValue: _ctx.form.destinationCity,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.destinationCity = $event)),
                    keyName: "name",
                    keyValue: "code",
                    selectAllText: "Semua",
                    selectAllClass: "font-normal",
                    placeholder: "Pilih kota tujuan",
                    "show-select-all": true,
                    "max-displayed-chips": 2,
                    allEnabled: "",
                    selectAllOption: "",
                    onFocus: _ctx.fetchCityDestination,
                    onFilter: _ctx.onFilterCityDestination,
                    class: "mt-1"
                  }, null, 8, ["options", "modelValue", "onFocus", "onFilter"])
                ]),
                _: 1
              }),
              _createVNode(_component_DataWrapper, {
                label: "User pembooking",
                optional: "",
                class: "mt-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_MultipleSelectSearchVirtualScroll, {
                    options: _ctx.createdByList,
                    modelValue: _ctx.form.createdBy,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.createdBy = $event)),
                    keyName: "name",
                    keyValue: "code",
                    selectAllText: "Semua",
                    selectAllClass: "font-normal",
                    placeholder: "Pilih user pembooking",
                    "show-select-all": true,
                    "max-displayed-chips": 2,
                    allEnabled: "",
                    selectAllOption: "",
                    onFocus: _ctx.fetchCreatedBy,
                    onFilter: _ctx.onFilterCreatedBy,
                    class: "mt-1"
                  }, null, 8, ["options", "modelValue", "onFocus", "onFilter"])
                ]),
                _: 1
              }),
              _createVNode(_component_DataWrapper, {
                label: "Moda",
                optional: "",
                class: "mt-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DropdownMultiSelect, {
                    modelValue: _ctx.form.cargoTypes,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.cargoTypes = $event)),
                    options: _ctx.modaOptions,
                    placeholder: "Pilih moda",
                    class: "mt-1",
                    "data-testid": "cargo-download-select-list-moda"
                  }, null, 8, ["modelValue", "options"])
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_LpButton, {
              color: "white",
              textColor: "red-lp-100",
              customClass: "border border-red-lp-100",
              title: "Batal",
              "is-width-full": "",
              outline: "",
              onClick: _ctx.onClose
            }, null, 8, ["onClick"]),
            _createVNode(_component_LpButton, {
              color: "red-lp-100",
              textColor: "white",
              title: "Simpan",
              "is-width-full": "",
              onClick: _ctx.onDownload,
              disabled: _ctx.disabled
            }, null, 8, ["onClick", "disabled"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}